module.exports = __webpack_public_path__ + "static/media/whichThinnerRecommended.2a8da11e.mp3";